import BaseApi from './base'

class AppUser extends BaseApi {
  constructor() {
    super()
    this.client.defaults.baseURL = `${this.fleetURL}/backoffice`
  }

  getUserSubscription = (id, query) =>
    this.client.get(`admin/subscriptions/subscriber/${id}?${query}`)

  getSubscriptionAllowedPilots = (id) =>
    this.client.get(`/users/${id}/allowed-pilots`)

  getListVehicleSharingExtension = (params) =>
    this.client.get(`/vehicle-sharing/extensions`, { params })

  getDetailVehicleSharing = ({ sharingId, ...params } = {}) => {
    return this.client.get(`/vehicle-sharing/extensions/${sharingId}`, {
      params
    })
  }

  forceStatusPermanentExtension = (id, data) =>
    this.client.patch(
      `/vehicle-sharing/force-update-permanent-extension/${id}/status`,
      data
    )

  forceStatusTemporalExtension = (id, data) =>
    this.client.patch(
      `/vehicle-sharing/admin-update-temporal-extension/${id}/status`,
      data
    )

  forceStatusUniqueExtension = (id, data) =>
    this.client.patch(
      `/vehicle-sharing/admin-update-unique-extension/${id}/status`,
      data
    )

  forceStatusCheckIn = (data) =>
    this.client.post('/vehicle-sharing/force-update-check-in-status', data)

  forceStatusCheckOut = (data) =>
    this.client.post('/vehicle-sharing/force-update-check-out-status', data)
}

export default new AppUser()
